import React from "react";

import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "./firebase";
import "./home-page.css";
import MarketingFooter from "./components/MarketingFooter";
import SEO from "./components/SEO";
import MarketingNavbar from "./components/MarketingNavbar";

export default function Partner() {
  const [errors, setErrors] = React.useState({});
  const [success, setSuccess] = React.useState(false);
  const [loading, setLoading] = React.useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const form = e.currentTarget;
    const formData = new FormData(form);

    const nome = String(formData.get("nome") || "").trim();
    const telefono = String(formData.get("telefono") || "").trim();
    const confermaTelefono = String(
      formData.get("confermaTelefono") || ""
    ).trim();

    const email = String(formData.get("email") || "").trim();
    const confermaEmail = String(
      formData.get("confermaEmail") || ""
    ).trim();

    const azienda = String(formData.get("azienda") || "").trim();
    const attivita = String(formData.get("attivita") || "").trim();
    const provincia = String(formData.get("provincia") || "").trim();
    const clienti = String(formData.get("clienti") || "").trim();
    const messaggio = String(formData.get("messaggio") || "").trim();

    setErrors({});
    setSuccess(false);

    const newErrors = {};

    if (nome.length < 2) {
      newErrors.nome = "Inserisci il tuo nome";
    }

    const telefonoPulito = telefono.replace(/\s+/g, "");
    const confermaTelefonoPulito = confermaTelefono.replace(/\s+/g, "");

    if (telefonoPulito.length < 6) {
      newErrors.telefono = "Numero di telefono non valido";
    }

    if (
      telefonoPulito.length >= 6 &&
      telefonoPulito !== confermaTelefonoPulito
    ) {
      newErrors.telefono = "I numeri non coincidono";
      newErrors.confermaTelefono = "I numeri non coincidono";
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(email)) {
      newErrors.email = "Email non valida";
    }

    if (email !== confermaEmail) {
      newErrors.email = "Le email non coincidono";
      newErrors.confermaEmail = "Le email non coincidono";
    }

    if (azienda.length < 2) {
      newErrors.azienda = "Inserisci il nome dell’azienda";
    }

    if (!attivita) {
      newErrors.attivita = "Seleziona la tipologia di attività";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setLoading(true);

    try {
      await addDoc(collection(db, "mail"), {
        to: "info@qrmenu-italia.it",
        message: {
          subject: "Nuova richiesta Partner QrMenu",
          text: `
Nuova richiesta Partner QrMenu

Nome e cognome: ${nome}
Telefono: ${telefonoPulito}
Email: ${email}
Azienda: ${azienda}
Tipologia attività: ${attivita}
Provincia o zona commerciale: ${provincia || "Non indicata"}
Numero indicativo di clienti: ${clienti || "Non indicato"}

Messaggio:
${messaggio || "Nessun messaggio inserito"}
          `.trim()
        },
        createdAt: serverTimestamp()
      });

      form.reset();
      setSuccess(true);
      setErrors({});
    } catch (err) {
      console.error(err);

      setErrors({
        general: "Errore durante l’invio. Riprova tra poco."
      });

      setSuccess(false);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="home-pro">
      <SEO
        title="Diventa Partner | QrMenu Italia"
        description="Diventa Partner QrMenu Italia e proponi ai tuoi clienti una piattaforma completa per menu digitale, ordini, cucina, sala, asporto e Intelligenza Artificiale."
        canonical="https://qrmenu-italia.it/partner"
        image="https://qrmenu-italia.it/logo512.png"
        keywords="partner qrmenu, rivenditore qrmenu, rivenditori registratori di cassa, software ristorazione, menu digitale partner"
      />

      <MarketingNavbar />

      <section className="hp-final" style={{ minHeight: "100vh" }}>
        <div className="hp-final-inner">
          <div className="contact-heading">
            <span className="contact-eyebrow">Programma Partner</span>

            <h1 className="hp-final-h2">
              Diventa Partner QrMenu
            </h1>

            <p className="hp-final-sub">
              Porta l’innovazione nei ristoranti dei tuoi clienti.
              Raccontaci della tua attività e scopri come proporre
              QrMenu ai locali della tua zona.
            </p>

            <div className="contact-benefits">
              <span>✓ Prodotto completo e innovativo</span>
              <span>✓ Formazione e supporto diretto</span>
              <span>✓ Opportunità di crescita commerciale</span>
            </div>
          </div>

          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="contact-field">
              <label htmlFor="partner-nome">Nome e cognome</label>

              <input
                id="partner-nome"
                name="nome"
                type="text"
                placeholder="Come ti chiami?"
                className={`contact-input ${
                  errors.nome ? "error" : ""
                }`}
                autoComplete="name"
                required
              />

              {errors.nome && (
                <span className="input-error">{errors.nome}</span>
              )}
            </div>

            <div className="contact-field">
              <label htmlFor="partner-telefono">Telefono</label>

              <input
                id="partner-telefono"
                name="telefono"
                type="tel"
                placeholder="Il tuo numero di telefono"
                className={`contact-input ${
                  errors.telefono ? "error" : ""
                }`}
                autoComplete="tel"
                inputMode="tel"
                required
              />

              {errors.telefono && (
                <span className="input-error">
                  {errors.telefono}
                </span>
              )}
            </div>

            <div className="contact-field">
              <label htmlFor="partner-conferma-telefono">
                Conferma telefono
              </label>

              <input
                id="partner-conferma-telefono"
                name="confermaTelefono"
                type="tel"
                placeholder="Ripeti il numero di telefono"
                className={`contact-input ${
                  errors.confermaTelefono ? "error" : ""
                }`}
                autoComplete="off"
                inputMode="tel"
                required
              />

              {errors.confermaTelefono && (
                <span className="input-error">
                  {errors.confermaTelefono}
                </span>
              )}
            </div>

            <div className="contact-field">
              <label htmlFor="partner-email">Email</label>

              <input
                id="partner-email"
                name="email"
                type="email"
                placeholder="La tua email"
                className={`contact-input ${
                  errors.email ? "error" : ""
                }`}
                autoComplete="email"
                inputMode="email"
                required
              />

              {errors.email && (
                <span className="input-error">{errors.email}</span>
              )}
            </div>

            <div className="contact-field">
              <label htmlFor="partner-conferma-email">
                Conferma email
              </label>

              <input
                id="partner-conferma-email"
                name="confermaEmail"
                type="email"
                placeholder="Ripeti la tua email"
                className={`contact-input ${
                  errors.confermaEmail ? "error" : ""
                }`}
                autoComplete="off"
                inputMode="email"
                required
              />

              {errors.confermaEmail && (
                <span className="input-error">
                  {errors.confermaEmail}
                </span>
              )}
            </div>

            <div className="contact-field">
              <label htmlFor="partner-azienda">
                Nome dell’azienda
              </label>

              <input
                id="partner-azienda"
                name="azienda"
                type="text"
                placeholder="Ragione sociale o nome commerciale"
                className={`contact-input ${
                  errors.azienda ? "error" : ""
                }`}
                autoComplete="organization"
                required
              />

              {errors.azienda && (
                <span className="input-error">
                  {errors.azienda}
                </span>
              )}
            </div>

            <div className="contact-field">
              <label htmlFor="partner-attivita">
                Tipologia di attività
              </label>

              <select
                id="partner-attivita"
                name="attivita"
                className={`contact-input ${
                  errors.attivita ? "error" : ""
                }`}
                defaultValue=""
                required
              >
                <option value="" disabled>
                  Seleziona la tua attività
                </option>

                <option value="Rivenditore registratori di cassa">
                  Rivenditore di registratori di cassa
                </option>

                <option value="Software house">
                  Software house
                </option>

                <option value="Consulente informatico">
                  Consulente informatico
                </option>

                <option value="Agenzia di comunicazione">
                  Agenzia di comunicazione
                </option>

                <option value="Commerciale o agente">
                  Commerciale o agente
                </option>

                <option value="Altro">
                  Altro
                </option>
              </select>

              {errors.attivita && (
                <span className="input-error">
                  {errors.attivita}
                </span>
              )}
            </div>

            <div className="contact-field">
              <label htmlFor="partner-provincia">
                Provincia o zona commerciale
              </label>

              <input
                id="partner-provincia"
                name="provincia"
                type="text"
                placeholder="Esempio: Ragusa e provincia"
                className="contact-input"
                autoComplete="address-level2"
              />
            </div>

            <div className="contact-field">
              <label htmlFor="partner-clienti">
                Numero indicativo di clienti{" "}
                <span>opzionale</span>
              </label>

              <input
                id="partner-clienti"
                name="clienti"
                type="text"
                placeholder="Esempio: circa 50 attività"
                className="contact-input"
              />
            </div>

            <div className="contact-field">
              <label htmlFor="partner-messaggio">
                Messaggio <span>opzionale</span>
              </label>

              <textarea
                id="partner-messaggio"
                name="messaggio"
                placeholder="Raccontaci brevemente della tua attività"
                className="contact-input contact-textarea"
                rows="5"
              />
            </div>

            <label className="contact-privacy">
              <input
                name="privacy"
                type="checkbox"
                required
              />

              <span>
                Ho letto e preso visione della{" "}
                <a
                  href="/privacy-policy"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Privacy Policy
                </a>
                .
              </span>
            </label>

            {errors.general && (
              <div className="contact-error-box" role="alert">
                <strong>Invio non riuscito</strong>
                <span>{errors.general}</span>
              </div>
            )}

            <button
              type="submit"
              className="hp-btn-primary hp-btn-xl contact-submit"
              disabled={loading}
            >
              {loading
                ? "Invio in corso..."
                : "Richiedi informazioni"}

              <span className="hp-btn-arrow">→</span>
            </button>
          </form>

          {success && (
            <div className="contact-success-box">
              <strong>Richiesta Partner inviata 🚀</strong>

              <span>
                Abbiamo ricevuto i tuoi dati. Ti contatteremo
                per illustrarti il programma Partner QrMenu.
              </span>
            </div>
          )}
        </div>
      </section>

      <MarketingFooter />
    </div>
  );
}